// TODO: Foundation2025 was never released and has no plans to be. Remove this file and all references.
import { BillingProcess, LimitNames, PlanTypes } from '@gonfalon/billing/types';

import { type Plan, CheckoutProcess } from '../types';

import { aiRunsProductDisplayOnly } from './products';

export const foundation2025Plan: Plan = {
  id: PlanTypes.FOUNDATION2025,
  planType: PlanTypes.FOUNDATION2025,
  billingProcess: BillingProcess.USAGE_BASED_BILLING,
  checkoutProcess: CheckoutProcess.CUSTOMIZE_COMMITS,
  isFoundationPlan: true, // Foundation2025 requires payment card
  recommended: true,
  disableIf: [{ planType: PlanTypes.FOUNDATION2025 }],
  marketingCopy: {
    name: 'Foundation',
    tagLine: 'A flexible platform for startups and growing teams',
    annualDiscount: '2 free months',
    pricingHeadline: '$36/month',
    pricingDescription: '2 months free with annual commitment',
    ctaButtonText: 'Select plan',
    featuresHeader: 'Everything in Developer, plus',
    features: [
      { text: 'Unlimited projects & environments' },
      {
        text: 'Frictionless, scalable usage',
        tooltip: {
          text: 'No hard limits - scale seamlessly as you grow',
        },
      },
      {
        text: 'Pre-pay discounts',
        tooltip: {
          text: 'Save money by committing to usage in advance',
        },
      },
      { text: 'Comprehensive audit log' },
      { text: '8 service connections per month' },
    ],
  },
  versions: {
    1: {
      planTitle: 'Foundation Plan',
      products: [
        {
          limitName: LimitNames.HOSTS,
          freeQuantity: 8,
          annualCommitDetails: {
            blockSize: 1,
            pricePerBlockCents: 10_000,
            maxQuantity: 500,
          },
          monthlyOverageDetails: {
            blockSize: 1,
            pricePerBlockCents: 1200,
          },
        },
        {
          limitName: LimitNames.MONTHLY_ACTIVE_USERS,
          freeQuantity: 1000,
          annualCommitDetails: {
            blockSize: 1000,
            pricePerBlockCents: 10_000,
            maxQuantity: 300_000,
          },
          monthlyOverageDetails: {
            blockSize: 1000,
            pricePerBlockCents: 1000,
          },
        },
        aiRunsProductDisplayOnly,
        {
          limitName: LimitNames.SESSIONS,
          hasBulkPricing: true,
          freeQuantity: 5000,
          annualCommitDetails: {
            blockSize: 1000,
            pricePerBlockCents: 3500,
            maxQuantity: 300_000,
            bulkPricingTiers: [
              { min: 5_000, max: 25_000, pricePerBlockCents: 3500 },
              { min: 25_000, max: 50_000, pricePerBlockCents: 3000 },
              { min: 50_000, max: 150_000, pricePerBlockCents: 2500 },
              { min: 150_000, max: 300_000, pricePerBlockCents: 2500 },
              { min: 300_000, max: 500_000, pricePerBlockCents: 2500 },
              { min: 500_000, max: 1_000_000, pricePerBlockCents: 1500 },
              { min: 1_000_000, max: 10_000_000, pricePerBlockCents: 1500 },
              {
                min: 10_000_000,
                max: Number.MAX_SAFE_INTEGER,
                pricePerBlockCents: 1500,
              },
            ],
          },
          monthlyOverageDetails: {
            blockSize: 1000,
            pricePerBlockCents: 350,
          },
        },
        {
          limitName: LimitNames.ERRORS,
          hasBulkPricing: true,
          freeQuantity: 5000,
          annualCommitDetails: {
            blockSize: 1000,
            pricePerBlockCents: 300,
            maxQuantity: 300_000,
            bulkPricingTiers: [
              { min: 5_000, max: 100_000, pricePerBlockCents: 300 },
              { min: 100_000, max: Number.MAX_SAFE_INTEGER, pricePerBlockCents: 130 },
            ],
          },
          monthlyOverageDetails: {
            blockSize: 1000,
            pricePerBlockCents: 30,
          },
        },
        {
          limitName: LimitNames.TRACES,
          freeQuantity: 10_000_000,
          annualCommitDetails: {
            blockSize: 1000000,
            pricePerBlockCents: 1500,
            maxQuantity: 100_000_000,
            bulkPricingTiers: [{ min: 10_000_000, max: Number.MAX_SAFE_INTEGER, pricePerBlockCents: 1500 }],
          },
          monthlyOverageDetails: {
            blockSize: 1000000,
            pricePerBlockCents: 150,
          },
        },
        {
          limitName: LimitNames.LOGS,
          freeQuantity: 10_000_000,
          annualCommitDetails: {
            blockSize: 1_000_000,
            pricePerBlockCents: 1500,
            maxQuantity: 100_000_000,
            bulkPricingTiers: [{ min: 10_000_000, max: Number.MAX_SAFE_INTEGER, pricePerBlockCents: 1500 }],
          },
          monthlyOverageDetails: {
            blockSize: 1000000,
            pricePerBlockCents: 150,
          },
        },
        {
          limitName: LimitNames.EXPERIMENTATION_MAU,
          isUnbilled: true,
          freeQuantity: 100_000,
          annualCommitDetails: {
            blockSize: 0,
            pricePerBlockCents: 0,
            maxQuantity: 100_000,
          },
          monthlyOverageDetails: {
            blockSize: 0,
            pricePerBlockCents: 0,
          },
        },
      ],
    },
  },
};
